import { IconSVG } from '../types';

export const Star = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      style={style}
    >
      <path d="M12 17.988l-4.551 2.878a.811.811 0 01-.51.13.9.9 0 01-.462-.18 1.02 1.02 0 01-.32-.407.83.83 0 01-.036-.555l1.208-5.418-4.018-3.647a.91.91 0 01-.254-1 1.04 1.04 0 01.272-.417.922.922 0 01.486-.21l5.303-.487 2.059-5.116a.824.824 0 01.34-.422.925.925 0 01.966 0 .824.824 0 01.34.422l2.059 5.116 5.303.486a.922.922 0 01.486.211c.118.108.209.247.272.417a.91.91 0 01-.254 1l-4.018 3.646 1.208 5.419a.83.83 0 01-.036.555 1.02 1.02 0 01-.32.407.9.9 0 01-.462.18.811.811 0 01-.51-.13L12 17.988z" />
    </svg>
  );
};
